import { render, staticRenderFns } from "./ForgotPasswordOTP.vue?vue&type=template&id=8cccaef4&scoped=true&"
import script from "./ForgotPasswordOTP.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordOTP.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordOTP.vue?vue&type=style&index=0&id=8cccaef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cccaef4",
  null
  
)

export default component.exports